module.exports = __webpack_public_path__ + "static/media/garboscore.32f34aee.png";